<template>
  <swipe-list
    ref="swipeListRef"
    class="card"
    :disabled="!enabled"
    :items="items"
    item-key="id"
    :disable-right-swipe="disableRightSwipe"
    @swipeout:click="itemClick"
    @closed="handleSwipeClosed"
    @revealed="handleSwipeRevealed"
  >
    <template v-slot="{ item, index, revealLeft, revealRight, close }">
      <slot
        :item="item"
        :index="index"
        :revealLeft="revealLeft"
        :revealRight="revealRight"
        :close="close"
      ></slot>
    </template>
    <template v-if="!disableRightSwipe"
      v-slot:right="{ item }"
    >
      <slot
        name="right"
        :item="item"
      ></slot>
    </template>
  </swipe-list>
</template>
<script setup>
import { ref, onMounted, watch } from 'vue'
import { SwipeList, SwipeOut } from 'vue-swipe-actions'

import 'vue-swipe-actions/dist/vue-swipe-actions.css'

const props = defineProps({
  items: {
    type: Array,
    default() {
      return []
    },
  },
  disableRightSwipe: {
    type: Boolean,
    default() {
      return false
    },
  },
})
const enabled = ref(true)
const isRevealed = ref(-1)
const swipeListRef = ref(null)
function close() {
  swipeListRef.value.closeActions()
  isRevealed.value = -1
}

defineExpose({ enabled, close, isRevealed })

function getValueFromTransform(transformString) {
  // const translateValue = 'transform: translate3d(-204px, 0px, 0px);';
  // console.log('transformString', transformString)
  return parseInt(transformString.match(/-\d+px/)[0], 10)
}
function translateX(x) {
  if (x === 0) { return '' }

  return `translate3d(${x}px, 0, 0)`
}

const emit = defineEmits(['closed', 'revealed', 'swipeout:click'])

function itemClick(e) {
  emit('swipeout:click', e)
}

function handleSwipeRevealed(revealEvent) {
  console.log(revealEvent)
  const swipeItems = swipeListRef.value.$refs.items
  for (let swipeItemIndex = 0; swipeItemIndex < swipeItems.length; swipeItemIndex += 1) {
    const listItem = swipeItems[swipeItemIndex]

    // console.log('listItem', listItem)
    if (swipeItemIndex === revealEvent.index) {
      setTimeout(() => {
        for (let itemIndex = 0; itemIndex < listItem.$children.length; itemIndex += 1) {
          const iconElement = listItem.$children[itemIndex]

          if (iconElement.$el.parentElement.className.includes('swipeout-action')) {
            // console.log('iconElement.$el.parentElement.style.cssText', iconElement.$el.parentElement.style.cssText)
            const newX = getValueFromTransform(iconElement.$el.parentElement.style.cssText) + 5

            // console.log('newX', newX)
            iconElement.$el.parentElement.style.transform = translateX(newX)

            emit('revealed', revealEvent)
            isRevealed.value = swipeItemIndex

            // console.log('iconElement.$el.parentElement.style ', iconElement.$el.parentElement.style)
          }
        }
      }, 30)
    } else {
      listItem.close()
    }
  }
}

function handleSwipeClosed(closeEvent) {
  console.log(closeEvent)
  const listItem = swipeListRef.value.$refs.items[closeEvent.index]
  setTimeout(() => {
    for (let itemIndex = 0; itemIndex < listItem.$children.length; itemIndex += 1) {
      const iconElement = listItem.$children[itemIndex]
      iconElement.$el.parentElement.style = ''

      // console.log('iconElement.$el.parentElement.style ', iconElement.$el.parentElement.style)
    }

    emit('closed', closeEvent)
  }, 30)
}

// function revealFirstRight() {
//   swipeListRef.value.revealRight(0)
// }
// function revealFirstLeft() {
//   swipeListRef.value.revealLeft(0)
// }
// function closeFirst() {
//   swipeListRef.value.closeActions(0)
// }
// function closeAll() {
//   swipeListRef.value.closeActions()
// }
// function remove(item) {
//   //   mockSwipeList.value = mockSwipeList.value.filter(i => i !== item)
// }
// function fbClick(e) {
//   console.log(e, 'First Button Click')
// }
// function sbClick(e) {
//   console.log(e, 'Second Button Click')
// }

</script>
